import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { OutboundLink } from "gatsby-plugin-google-analytics"

import attnLogo from "~/images/attn-logo-navy.svg"

const Header = () => {
  const data = useStaticQuery(graphql`
    query {
      sceLogo: file(name: { eq: "sce-logo" }) {
        childImageSharp {
          fluid(maxWidth: 130) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      chicagoIdeasLogo: file(name: { eq: "chicago-logo-horizontal" }) {
        childImageSharp {
          fluid(maxWidth: 130) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)
  const { sceLogo, chicagoIdeasLogo } = data
  return (
    <header className="flex items-center mx-auto h-header-small md:h-header-large mx-content-mobile md:mx-content">
      <OutboundLink
        className="attn-logo"
        href="https://www.attn.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={attnLogo} alt="Attn Logo" className="w-full" />
      </OutboundLink>
      <div className="flex-1"></div>
      <OutboundLink
        className="sce-logo mr-4 lg:mr-6"
        href="http://www.scefdn.org/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Img fluid={sceLogo.childImageSharp.fluid} alt="SCE Logo" />
      </OutboundLink>
      <OutboundLink
        className="chicago-logo"
        href=" https://www.chicagoideas.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Img
          fluid={chicagoIdeasLogo.childImageSharp.fluid}
          alt="Chicago Ideas Logo"
        />
      </OutboundLink>
    </header>
  )
}

export default Header
